import { useQuery } from "@apollo/client";
import { CircularProgress } from "@mui/material";
import { getCodeGroupByIds } from "../../../graphql/queries/codeGroupQueries";
import { getAllCodeGroupIds } from "../../jsonForms/shared/codeGroupUtils";

const SelectedCodeGroups = ({ data }) => {
  const codeGroupIds = getAllCodeGroupIds(data.code_group_ids);
  const { data: selectedCodeGroups, loading } = useQuery(getCodeGroupByIds, {
    variables: { ids: codeGroupIds },
  });

  return (
    <div className="additional-fields-container">
      <div className="field-pair" style={{ flexBasis: "31% !important" }}>
        <span className="field-label">Code Groups: </span>
      </div>
      <div className="field-pair-two-column">
        {loading ? (
          <CircularProgress />
        ) : (
          <span className="field-value">
            {selectedCodeGroups?.loadCodeGroupsByIds?.length
              ? selectedCodeGroups?.loadCodeGroupsByIds?.map((codeGroup) => (
                  <span
                    key={codeGroup.codeGroupId}
                    style={{
                      backgroundColor:
                        codeGroup.compositeStatus === "INACTIVE"
                          ? "#dfdfdf"
                          : "inherit",
                      marginRight: "8px",
                    }}
                  >
                    {codeGroup?.basicSetup?.codeGroupName || ""}
                  </span>
                ))
              : "-"}
          </span>
        )}
      </div>
    </div>
  );
};

export default SelectedCodeGroups;
